export function useScrollTo() {
  const scrollTo = (element: any, minus?: number) => {
    if (!import.meta.client) {
      return;
    }
    const y = minus ? element.getBoundingClientRect().top + window.pageYOffset - minus : element.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return { scrollTo };
}
